export const DEFAULT_DUES_DRAWER_TITLE = 'Pay membership dues';
export const DUES_SELECT_WIZARD_TITLE = 'Renewal: Steps 1 and 2';
export const DUES_CONTRIBUTIONS_TITLE = 'Renewal: Step 3 of 4';
export const DUES_HEADER_CHANGE = 'seva:dues-header-change';
